var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1280 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0l53 4.17c54 4.171 160 12.512 267 26.628 107 14.436 213 34.968 320 39.138 107 4.17 213-8.34 320-12.19 107-4.17 213 0 267 1.924l53 1.925V111H0V0z",
    fill: "#20B1DF",
    fillOpacity: 0.46
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 44.4l42.667 8.88c42.666 8.88 128 26.64 213.333 22.2 85.333-4.44 170.667-31.08 256-48.84C597.333 8.88 682.667 0 768 0s170.667 8.88 256 24.42c85.33 15.54 170.67 37.74 213.33 48.84l42.67 11.1V111H0V44.4z",
    fill: "#E5E5E5",
    fillOpacity: 0.13
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectors);
export default __webpack_public_path__ + "static/media/vectors.f5c48c5e651fed88e03b4f76d91b166f.svg";
export { ForwardRef as ReactComponent };